<template>
  <div class="nudges margin-subpages">
    <div class="columns-size px-4 pt-12 pb-24">
      <div class="cell fs-14 fw-700">{{ $t("sparks.nudges_col_dimension") }}</div>
      <div class="cell fs-14 fw-700">{{ $t("sparks.nudges_col_nudge") }}</div>
      <div class="cell fs-14 fw-700">{{ $t("sparks.nudges_col_recipient") }}</div>
      <div class="cell fs-14 fw-700 right">{{ $t("sparks.nudges_col_date_time") }}</div>
    </div>
    <div v-for="arr in nudgesData" :key="arr.id">
      <div class="relative" :data-id="arr.id">
        <div
          :class="`${arr.status} ${
            arr.duplicateValue &&
            !arr.showDuplicateValue &&
            arr.child.length > 1
              ? ''
              : 'showing'
          }`"
          class="card-layer"
          style="top: 16px; left: 16px"
        >
          &nbsp;
        </div>
        <div
          :class="`${arr.status} ${
            arr.duplicateValue &&
            !arr.showDuplicateValue &&
            arr.child.length > 1
              ? ''
              : 'showing'
          }`"
          class="card-layer"
          style="top: 8px; left: 8px"
        >
          &nbsp;
        </div>
        <div class="columns-size nudge-card" :class="arr.status">
          <div class="cell flex-center">
            <img
              :src="retrunTypName(arr.imageName)"
              class="dimension-img image-skeleton d-none"
              style="height: 32px"
            />
            <div class="fw-700">{{ arr.dimension }}</div>
          </div>
          <el-tooltip :content="arr.label" placement="top">
            <div class="cell ellipsis text">
              {{ arr.label }}
            </div>
          </el-tooltip>
          <div class="cell fw-500">
            <div class="ellipsis"
            :class="[ blurMode ?  'blurelement': '' ]">{{ arr.recipient }}</div>
          </div>
          <div class="cell opa-06">
            <div class="ellipsis right">{{ prettyDate(arr.dateAndTime) }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="arr.duplicateValue"
        :class="{ 'expand-card': arr.showDuplicateValue }"
        class="duplicate-card-container"
        :style="`height: ${
          arr.showDuplicateValue ? arr.child.length * (64 + 12) : '0'
        }px`"
      >
        <div
          v-for="data in arr.child"
          :key="data.id"
          class="columns-size nudge-card" :class="data.status" :data-id="data.id"
        >
          <div class="cell flex-center">
            <img
              :src="retrunTypName(data.imageName)"
              class="dimension-img image-skeleton"
              style="height: 32px"
            />
            <div class="fw-700">{{ data.dimension }}</div>
          </div>
          <div class="cell ellipsis text">
            {{ data.label }}
          </div>
          <div class="cell fw-500">
            <div class="ellipsis"
            :class="[ blurMode ?  'blurelement': '' ]">{{ data.recipient }}</div>
          </div>
          <div class="cell opa-06">
            <div class="ellipsis right">{{ prettyDate(data.dateAndTime) }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="arr.duplicateValue && !arr.showDuplicateValue"
        class="flex-mid"
        :class="`mt-${arr.totalItems > 1 ? '16' : '14'}`"
      >
        <div @click="showFeedSet(arr)" class="expand-dup">
          {{ $t("sparks.nudges_expand_all") }} ({{ arr.totalItems }})
        </div>
      </div>
      <div
        v-else-if="arr.duplicateValue && arr.showDuplicateValue"
        class="flex-mid"
      >
        <div @click="hideFeedSet(arr)" class="expand-dup">
          {{ $t("sparks.nudges_hide_all") }} ({{ arr.totalItems }})
        </div>
      </div>
    </div>
    <div v-if="loadingNudges">
      <div
        class="columns-size nudge-card text-skeleton opa-07"
      >
        <div class="cell flex-center">
          <div
            class="dimension-img image-skeleton opa-02"
            style="height: 32px"
          ></div>
          <div class="fw-700 text-skeleton" style="width: 55%">&nbsp;</div>
        </div>
        <div class="cell ellipsis text-skeleton" style="width: 70%">&nbsp;</div>
        <div class="cell opa-06 fw-500 text-skeleton" style="width: 50%">
          &nbsp;
        </div>
        <div class="cell opa-03 text-skeleton ml-auto mr-20" style="width: 50%">
          &nbsp;
        </div>
      </div>
      <div
        class="columns-size nudge-card text-skeleton opa-04"
      >
        <div class="cell flex-center">
          <div
            class="dimension-img image-skeleton opa-02"
            style="height: 32px"
          ></div>
          <div class="fw-700 text-skeleton" style="width: 55%">&nbsp;</div>
        </div>
        <div class="cell ellipsis text-skeleton" style="width: 70%">&nbsp;</div>
        <div class="cell opa-06 fw-500 text-skeleton" style="width: 50%">
          &nbsp;
        </div>
        <div class="cell opa-03 text-skeleton ml-auto mr-20" style="width: 50%">
          &nbsp;
        </div>
      </div>
      <div
        class="columns-size nudge-card text-skeleton opa-03"
        style="width: 60%"
      >
        <div class="cell flex-center">
          <div
            class="dimension-img image-skeleton opa-02"
            style="height: 32px"
          ></div>
          <div class="fw-700 text-skeleton" style="width: 55%">&nbsp;</div>
        </div>
      </div>
    </div>
    <div
      v-if="loadingMoreNudges && !loadingNudges"
      class="load-more flex-mid mx-auto mt-32 mb-32"
    >
      <i class="el-icon-loading"></i>
    </div>
    <div
      v-else-if="!loadingNudges && hasMore"
      @click="loadMore"
      class="load-more flex-mid mx-auto mt-32 mb-32"
    >
      {{ $t("sparks.nudges_load_more") }}
    </div>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "Nudges",
  data() {
    return {
      // loadingNudges: true,
      // loadingMoreNudges: false,
      _________________nudgesData: [
        // {
        //   id: "1111-1-1-11-1-1-111",
        //   dimension: "satisfaction",
        //   imageName: "satisfaction",
        //   label:
        //     "✅ 92% of your team has seen a positive change from recent feedback. Great effort listening, taking action, and managing. Great effort listening, taking action, and managin",
        //   recipient: "Joe Field",
        //   dateAndTime: "Today at 11:15 PM",
        //   status: "white",
        //   duplicateValue: false,
        //   showDuplicateValue: false, // set: false
        //   child: [],
        // },
      ],
    };
  },
  computed: {
    loadingNudges() {
      return this.$store.getters["nudges/loading"];
    },
    loadingMoreNudges() {
      return this.$store.getters["nudges/loadingChildren"];
    },
    nudgesData() {
      return this.$store.getters["nudges/feeds"];
    },
    hasMore() {
      return this.$store.getters["nudges/hasMore"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingNudges = false;
    //   this.mockData();
    // }, 2000)

    this.getFeeds();
  },
  beforeDestroy() {
    this.$store.dispatch("nudges/disposeFeedListeners", null, { root : true });
  },
  methods: {
    getFeeds(latestDate = null) {
      this.$store.dispatch("nudges/getFeeds", latestDate, { root : true });
    },
    showFeedSet(feed) {
      this.$store.dispatch("nudges/showFeedSet", feed, { root : true });
    },
    hideFeedSet(feed) {
      this.$store.dispatch("nudges/hideFeedSet", feed, { root : true });
    },
    loadMore() {
      const nextLatestDate = this.$store.getters["nudges/nextLatestDate"];
      this.getFeeds(nextLatestDate);
    },
    mockData() {
      console.log("mockData()");
      for (let i = 0; i < 11; i++) {
        const status = Math.floor(Math.random() * 2);
        let id = +new Date();
        let data = {
          id: id + "-" + i,
          dimension: i % 2 ? "Recognition" : "Rel.Manager",
          imageName: i % 2 ? "Recognition" : "Rel.Manager",
          label:
            "✅ 92% [" +
            i +
            "] of your team has seen a positive change from recent feedback. Great effort listening, taking action, and managing. Great effort listening, taking action, and managin",
          recipient: "Joe Field",
          dateAndTime: i < 2 ? "Yesterday at 9:36 PM" : "Jun 4 at 11:15 PM",
          status: i % 3 ? "red" : i % 2 ? "green" : "white",
          duplicateValue: false,
          showDuplicateValue: false,
          child: [],
        };

        if (status == 0) {
          this.nudgesData.push(data);
        } else if (status == 1) {
          const length = Math.floor(Math.random() * 40) + 1;
          data.duplicateValue = true;
          for (let index = 0; index < length; index++) {
            data.child.push({
              id: id + "-" + length + "-" + index,
              dimension: i % 2 ? "Recognition" : "Rel.Manager",
              imageName: i % 2 ? "Recognition" : "Rel.Manager",
              label:
                "✅ 92% [" +
                i +
                "_" +
                index +
                "] of your team has seen a positive change from recent feedback. Great effort listening, taking action, and managing. Great effort listening, taking action, and managin",
              recipient: "Joe Field",
              dateAndTime: i < 2 ? "Yesterday at 9:36 PM" : "Jun 4 at 11:15 PM",
              status: i % 3 ? "red" : i % 2 ? "green" : "white",
            });
          }
          this.nudgesData.push(data);
        }
      }
    },
    loadmore() {
      // this.loadingMoreNudges = true;
      setTimeout(() => {
        // this.loadingMoreNudges = false;
        this.mockData();
      }, 2000);
    },
    retrunTypName(pic) {
      // "Ambassadorship",
      // "Company-Alignment",
      // "Feedback",
      // "Happiness",
      // "Introspection",
      // "Personal-Growth",
      // "Recognition",
      // "Rel.Colleagues",
      // "Rel.Manager",
      // "Satisfaction",
      // "wellness",
      const images = require.context(
        "@/assets/images/dimension/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    prettyDate(datetime) {
      if (!datetime) return;

      const now = new Date();
      const target = new Date(datetime).toISOString().split('T')[0];
      const today = now.toISOString().split('T')[0];
      now.setDate(now.getDate() - 1);
      const yesterday = now.toISOString().split('T')[0];

      // @see https://date-fns.org/v1.29.0/docs/format
      let result = format(datetime, "MMM D");
      const time = format(datetime, "h:mm A");
      if (target == today) {
        result = "Today";
      } else if (target == yesterday) {
        result = "Yesterday";
      }
      result += ` at ${time}`;

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-layer,
.nudge-card {
  box-shadow: 0px 1px 4px #00000029;
  border-radius: 9px;
  padding: 0 4px;
  font-size: 13px;
  height: 64px;
  display: flex;
  align-items: center;
  transition: 0.3s;
  margin-bottom: 12px;
  transition: 0.3s;
}
.nudge-card {
  position: relative;
}
.card-layer {
  width: 100%;
  padding: 0;
  position: absolute;
  transition: 0.15s;
}
.card-layer.showing {
  opacity: 0;
  bottom: calc((64px + 12px) * -1);
}
.card-layer.green,
.nudge-card.green {
  background-color: #f5fff9;
  &:hover {
    background-color: #eafff2;
  }
}
.card-layer.white,
.nudge-card.white {
  background-color: #fff;
  &:hover {
    background-color: rgb(250, 250, 250);
  }
}
.card-layer.red,
.nudge-card.red {
  background-color: #fff5f5;
  &:hover {
    background-color: #ffeded;
  }
}
.duplicate-card-container {
  height: 0px;
  transition: 0.3s;
  overflow: hidden;
}
.expand-card {
  overflow: unset;
}
.columns-size {
  display: grid;
  grid-template-columns: 200px auto 130px 170px;
  .cell {
    color: #000;
    padding: 0px 12px;
  }
  .cell.text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @supports (-webkit-line-clamp: 2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.expand-dup {
  color: #32c2d5;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 12px;
}
.dimension-img {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  object-fit: cover;
  margin-right: 12px;
}
.load-more {
  width: 98px;
  height: 29px;
  border-radius: 29px;
  background-color: rgba($color: #000000, $alpha: 0.1);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
</style>
